module.exports = __webpack_public_path__ + "img/select-lang-header.6d7f9f80.png";